module.exports = __webpack_public_path__ + "res/ic_view.1b5e96a5ff671f891a2c73150d7839ab.png";